// Centralised content for VPCL Infra Limited

export const COMPANY = {
  name: "VPCL Infra Limited",
  short: "VPCL Infra",
  tagline: "Building India's Renewable Infrastructure Future",
  phone: "+91 XXXX-XXXXXX",
  email: "corporate@vpclinfra.com",
  landownerEmail: "landowner@vpclinfra.com",
  address: {
    line1: "VPCL Corporate Tower",
    line2: "Plot No. XX, Financial District",
    city: "Hyderabad, Telangana",
    pin: "500032",
    country: "India",
  },
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121809.34!2d78.36!3d17.41!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb96b06efd9b81%3A0x6b8b794d4a4fb!2sHyderabad!5e0!3m2!1sen!2sin!4v1700000000000",
  cin: "U40300TGXXXXPLCXXXXXX",
  gst: "36XXXXXXXXXX1ZX",
  msme: "UDYAM-TS-XX-XXXXXXX",
  iso: "ISO 9001:2015 | ISO 14001:2015 | ISO 45001:2018",
};

export const HERO_STATS = [
  { value: "750", suffix: " MW", label: "Capacity Developed" },
  { value: "420", suffix: " MW", label: "Under Execution" },
  { value: "60", suffix: "+", label: "Institutional Clients" },
  { value: "14", suffix: "", label: "States Served" },
];

export const SERVICES = [
  {
    slug: "utility-scale-epc",
    title: "Utility Scale Solar EPC",
    summary: "Turnkey EPC for 50 MW+ ground-mount projects, from BoQ to grid synchronisation.",
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "pm-kusum",
    title: "PM-KUSUM Projects",
    summary: "Component-A & C developer for MNRE PM-KUSUM tenders with DISCOM-anchored PPAs.",
    icon: "Sun",
    image: "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "government-solar",
    title: "Government Solar Projects",
    summary: "Empanelled execution partner for Central & State PSU and DISCOM tenders.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "open-access",
    title: "Open Access Solar",
    summary: "Third-party sale projects with banking, wheeling and CEIG approvals managed end-to-end.",
    icon: "Network",
    image: "https://images.pexels.com/photos/8783541/pexels-photo-8783541.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    slug: "captive-solar",
    title: "Captive Solar Plants",
    summary: "Group captive structures (26% equity) tailored for HT industrial consumers.",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "solar-parks",
    title: "Solar Parks",
    summary: "Mode-5 / Mode-8 solar park development with land aggregation and substation infra.",
    icon: "LandPlot",
    image: "https://images.pexels.com/photos/35501726/pexels-photo-35501726.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    slug: "om-services",
    title: "Operation & Maintenance",
    summary: "Long-term O&M with SCADA, drone thermography and 24x7 NOC monitoring.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "project-development",
    title: "Project Development",
    summary: "Land, DPR, evacuation, financial closure & PPA bidding under one development desk.",
    icon: "FileSpreadsheet",
    image: "https://images.pexels.com/photos/5504388/pexels-photo-5504388.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export const WHY_VPCL = [
  {
    title: "Utility Scale Expertise",
    body: "Proven 50 MW+ project delivery with single-point EPC accountability across Central & Southern grids.",
    icon: "Gauge",
  },
  {
    title: "Government Tender Experience",
    body: "Empanelled with multiple DISCOMs and a track record across MNRE, SECI and state nodal agency tenders.",
    icon: "ShieldCheck",
  },
  {
    title: "End-to-End EPC Solutions",
    body: "Design, supply, installation, evacuation and commissioning delivered in-house with FAT-tested components.",
    icon: "Layers",
  },
  {
    title: "Strong Execution Team",
    body: "Site teams led by ex-NTPC, ex-Adani Solar professionals with HSE-first project culture.",
    icon: "Users",
  },
];

export const GOV_PROGRAMS = [
  { name: "PM-KUSUM", desc: "Component-A & C feeder-level solarisation projects." },
  { name: "APDISCOM", desc: "Distribution-tied EPC works for Andhra Pradesh utilities." },
  { name: "Telangana DISCOM", desc: "Substation-linked utility scale projects for TSSPDCL & TSNPDCL." },
  { name: "Government PPA Projects", desc: "Long-term PPAs anchored by state & central agencies." },
  { name: "Open Access Projects", desc: "Wheeling-based third-party sale to HT consumers." },
  { name: "Captive Solar Projects", desc: "Group captive structures with 26% equity participation." },
  { name: "Utility Scale Installations", desc: "Grid-connected plants with CTU/STU evacuation." },
];

export const PROJECTS = [
  {
    slug: "rayalaseema-150mw",
    name: "Rayalaseema Solar Park",
    capacity: "150 MW",
    location: "Anantapur, Andhra Pradesh",
    client: "APDISCOM (via SECI)",
    scope: "EPC + 5 Yr O&M",
    completion: "Mar 2024",
    status: "Operational",
    image: "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    highlights: [
      "Single-largest ground-mount EPC delivered by VPCL",
      "220 kV pooling substation built in-house",
      "1.8 lakh bifacial modules with single-axis trackers",
    ],
    summary:
      "A flagship 150 MW utility-scale plant anchored by APDISCOM. Delivered ahead of schedule with a 220 kV pooling substation and dedicated 14 km transmission corridor.",
  },
  {
    slug: "telangana-kusum-75mw",
    name: "Telangana PM-KUSUM Cluster",
    capacity: "75 MW",
    location: "Mahbubnagar, Telangana",
    client: "TSSPDCL",
    scope: "PM-KUSUM Component-C Feeder Solarisation",
    completion: "Aug 2024",
    status: "Operational",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    highlights: [
      "9 feeder-level plants across 3 districts",
      "11 kV interconnection at DISCOM substations",
      "Day-time supply to 14,000+ agricultural pumps",
    ],
    summary:
      "Feeder-level solarisation program covering 9 sites, delivering day-time agri power across Mahbubnagar district under PM-KUSUM Component-C.",
  },
  {
    slug: "captive-gujarat-50mw",
    name: "Gujarat Group Captive Project",
    capacity: "50 MW",
    location: "Kutch, Gujarat",
    client: "Multi-consumer Captive SPV",
    scope: "Open Access + Captive EPC",
    completion: "Dec 2023",
    status: "Operational",
    image: "https://images.pexels.com/photos/35501726/pexels-photo-35501726.jpeg?auto=compress&cs=tinysrgb&w=1600",
    highlights: [
      "Group captive structure with 9 HT industrial offtakers",
      "Open access wheeling through GETCO 66 kV network",
      "Tariff savings of 38% vs DISCOM HT tariff",
    ],
    summary:
      "A 50 MW group-captive project serving 9 industrial offtakers across Gujarat under the open access regime.",
  },
  {
    slug: "karnataka-park-200mw",
    name: "Karnataka Solar Park Phase II",
    capacity: "200 MW",
    location: "Tumakuru, Karnataka",
    client: "KSPDCL",
    scope: "Solar Park Development + EPC",
    completion: "Under Execution",
    status: "Under Execution",
    image: "https://images.pexels.com/photos/8783541/pexels-photo-8783541.jpeg?auto=compress&cs=tinysrgb&w=1600",
    highlights: [
      "Mode-5 solar park with land aggregation by VPCL",
      "400 kV pooling substation under construction",
      "Scheduled COD: Q3 FY26",
    ],
    summary:
      "200 MW Mode-5 solar park with full land aggregation and 400 kV substation infrastructure. Currently in advanced construction.",
  },
  {
    slug: "maharashtra-openaccess-30mw",
    name: "Maharashtra Open Access Plant",
    capacity: "30 MW",
    location: "Solapur, Maharashtra",
    client: "Confidential HT Consumer",
    scope: "EPC + Wheeling Approvals",
    completion: "Jun 2023",
    status: "Operational",
    image: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    highlights: [
      "Third-party sale to a single HT consumer",
      "All MSEDCL / MSETCL approvals managed in-house",
      "Achieved CUF of 22.4% in Year 1",
    ],
    summary:
      "30 MW open access plant supplying a single HT consumer in Solapur through wheeling arrangements with MSEDCL.",
  },
  {
    slug: "rajasthan-utility-100mw",
    name: "Rajasthan Utility Plant",
    capacity: "100 MW",
    location: "Bikaner, Rajasthan",
    client: "RVPN / SECI",
    scope: "EPC",
    completion: "Feb 2023",
    status: "Operational",
    image: "https://images.pexels.com/photos/5504388/pexels-photo-5504388.jpeg?auto=compress&cs=tinysrgb&w=1600",
    highlights: [
      "Bifacial + tracker configuration",
      "220 kV LILO to existing transmission line",
      "Delivered 12 weeks ahead of contract schedule",
    ],
    summary:
      "100 MW utility-scale plant in Bikaner connected via 220 kV LILO. Built using bifacial modules with single-axis trackers.",
  },
];

export const INDUSTRIES = [
  {
    title: "Government Agencies",
    body: "Central & State PSUs, DISCOMs, nodal agencies for renewable energy procurement.",
  },
  {
    title: "Industrial Clients",
    body: "Cement, steel, chemicals and pharma plants seeking captive/open-access power.",
  },
  {
    title: "Commercial Enterprises",
    body: "IT parks, data centres and retail chains targeting renewable Scope-2 reductions.",
  },
  {
    title: "Utility Companies",
    body: "State and central transmission utilities for grid-connected utility infra.",
  },
  {
    title: "Infrastructure Developers",
    body: "JV partners for solar park development, land aggregation and EPC consortia.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "VPCL Infra delivered our 150 MW project ahead of schedule with zero LD events. Their substation team is among the best we have worked with.",
    name: "Senior Project Officer",
    org: "Andhra Pradesh DISCOM (APDISCOM)",
  },
  {
    quote:
      "From land aggregation to PPA execution, VPCL acted as a true development partner. Their KUSUM cluster execution sets a benchmark for the industry.",
    name: "Chief General Manager",
    org: "Telangana State Utility",
  },
  {
    quote:
      "Our 50 MW group captive plant has been operational for 18 months at >22% CUF. VPCL's O&M backbone is genuinely investor-grade.",
    name: "Director - Strategy",
    org: "Industrial Group, Gujarat",
  },
];

export const DIRECTORS = [
  {
    name: "Director Profile - 1",
    role: "Managing Director",
    bio: "Ex-utility & EPC leadership with 25+ years across renewable infrastructure delivery.",
  },
  {
    name: "Director Profile - 2",
    role: "Whole-time Director",
    bio: "Project finance, PPA structuring and DPR specialist with multi-state deal history.",
  },
  {
    name: "Director Profile - 3",
    role: "Independent Director",
    bio: "Former senior bureaucrat with deep tendering and regulatory advisory background.",
  },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/government-projects", label: "Government" },
  { to: "/landowner", label: "Landowner" },
  { to: "/credibility", label: "Credibility" },
  { to: "/contact", label: "Contact" },
];
